export const calculateGridTemplateColumns = (numColumns: number): string => {
  const leftSide = 2; // percentage for the left side column
  const rightSide = 7; // percentage for the right side column
  const count = Math.max(numColumns, 0); // ensure non-negative column count
  const middle = Math.max(100 - leftSide - rightSide, 0); // percentage for the middle columns
  const each = count > 0 ? middle / count : middle; // percentage for each middle column

  // Construct the grid template string
  return `${leftSide}% ${Array.from({ length: count }, () => `${each}%`).join(' ')} ${rightSide}%`.trim();
};
